module.exports = __webpack_public_path__ + "static/media/KW.168b2193.svg";